const config = {
  development: {
    sitelocked: false,
  },
  staging: {
    sitelocked: false,
  },
  production: {
    sitelocked: false,
  },
};

export default config;
